export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-accent-500"></i>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 font-bold">
                关于悟空
              </h2>
            </div>
            <p className="text-sm text-foreground-400 mb-6 ml-11">
              悟空影视电影大全 - 为影迷而生
            </p>

            <div className="ml-11 space-y-4">
              <p className="text-sm text-foreground-300 leading-relaxed">
                悟空影视是一个专注于高清电影在线观看的综合平台。我们汇聚了动作片、喜剧片、科幻片、悬疑片、爱情片等海量题材，致力于为每一位影迷提供流畅、高清、免费的观影体验。
              </p>
              <p className="text-sm text-foreground-300 leading-relaxed">
                悟空影视最新电影每日更新，从院线热门到经典佳片，从国产精品到海外巨制，我们的片库持续扩增。无需注册、无需缓冲，即点即播，让观影回归最简单的快乐。
              </p>
              <p className="text-sm text-foreground-300 leading-relaxed">
                我们相信，每一部好电影都值得被看见。悟空影视团队将持续优化播放体验，丰富内容覆盖，为大家带来更便捷、更优质的在线观影服务。
              </p>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[400px] h-[240px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20amber%20and%20golden%20home%20theater%20room%20with%20soft%20lighting%2C%20large%20screen%20showing%20abstract%20cinematic%20visuals%2C%20comfortable%20seating%2C%20cozy%20atmosphere%2C%20film%20reels%20and%20movie%20posters%20on%20walls%2C%20dark%20wood%20accents%2C%20professional%20cinema%20aesthetic%2C%20elegant%20interior%20design%2C%20warm%20color%20grading%2C%20inviting%20ambiance&width=800&height=480&seq=wukong-about-visual&orientation=landscape"
                alt="悟空影视 - 为影迷打造的高清在线观影平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-background-100/60 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}